import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Alert } from '@mui/material';

function SummaryContainer({ summaryintro, summarycloser}) {
    return (
      <Container className='bg-dark text-light pt-5 ' >
        <Row>
          <Col className='pt-5'>
                    <p className='lead'>
                       <b> { summaryintro }</b>
                    </p>
                    <p className='lead'>
                       <b>{ summarycloser }</b> 
                    </p>
                    <p></p>
          </Col>
        </Row>
      </Container>
    );
}

export default SummaryContainer;